import type { FunctionComponent } from 'react'
import React from 'react'

import type { HubPageContentItem } from '../../../../generated/frontend'
import { AccordionSection } from '../../../../shared/components/AccordionSection'
import { CurrentStory } from '../../../../shared/components/CurrentStory'
import { MultiLinkBlocks } from '../../../../shared/components/MultiLinkBlocks'
import { NewsletterSignUpWithImage } from '../../../../shared/components/NewsletterSignUpWithImage'
import { PodcastInfo } from '../../../../shared/components/PodcastInfo'
import { ConversationArticles } from '../../components/ConversationArticles'
import { HubPageToolCTA } from '../HubPageToolCTA'
import styles from './HubPageSections.module.scss'

export const HubPageSections: FunctionComponent<Props> = ({ contentItems }) => {
  if (!contentItems.length) {
    return null
  }

  return (
    <>
      {contentItems.map(({ type, data }, index) => {
        const Component = componentMapper[type]

        if (Component) {
          return (
            <section key={`${type}-${index}`} className={styles[`${type}Section`]}>
              <Component {...data} />
            </section>
          )
        }

        return null
      })}
    </>
  )
}

///////// IMPLEMENTATION /////////

type Props = {
  contentItems: HubPageContentItem[]
}

// TODO: Create a type of all possible content type
// (E.g.: podcastCollection, etc) to type this mapper better
const componentMapper: Record<string, FunctionComponent<any>> = {
  accordionSection: AccordionSection,
  podcastCollection: PodcastInfo,
  currentStoryCollection: CurrentStory,
  conversationWidget: ConversationArticles,
  multiLinkCollection: MultiLinkBlocks,
  newsletterSignUpWithImage: NewsletterSignUpWithImage,
  toolCTA: HubPageToolCTA,
}
